// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SEO_BABY = "Baz\u00e1r";
export const CURRENCY_ISO = "EUR";
